import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdayDetayPage from './AdayDetayPage';

const elendi = (a) => a.telefon_durumu === 'elendi' || a.musteri_durumu === 'elendi' || a.teklif_durumu === 'reddedildi';

const telefonEtiket = {
  'ulasilamadi': { label: 'Ulasilamadi', renk: 'badge-bekliyor' },
  'ulas\u0131lamad\u0131': { label: 'Ulasilamadi', renk: 'badge-bekliyor' },
  'tarih_belirlendi': { label: 'Tarih Belirlendi', renk: 'badge-bekliyor' },
  'gecti': { label: 'Gecti', renk: 'badge-tamamlandi' },
  'elendi': { label: 'Elendi', renk: 'badge-hata' },
};

const musteriEtiket = {
  'beklemede': { label: 'Beklemede', renk: 'badge-bekliyor' },
  'tarih_belirlendi': { label: 'Tarih Belirlendi', renk: 'badge-bekliyor' },
  'gecti': { label: 'Gecti', renk: 'badge-tamamlandi' },
  'elendi': { label: 'Elendi', renk: 'badge-hata' },
};

const teklifEtiket = {
  'sozlu_yapildi': { label: 'Sozlu Yapildi', renk: 'badge-bekliyor' },
  'resmi_gonderildi': { label: 'Gonderildi', renk: 'badge-bekliyor' },
  'kabul_edildi': { label: 'Kabul', renk: 'badge-tamamlandi' },
  'reddedildi': { label: 'Red', renk: 'badge-hata' },
  'sozlesme_gonderildi': { label: 'Sozlesme', renk: 'badge-bekliyor' },
  'sozlesme_imzalandi': { label: 'Imzalandi', renk: 'badge-tamamlandi' },
  'evraklar_yuklendi': { label: 'Tamamlandi', renk: 'badge-tamamlandi' },
};

const Durum = ({ bilgi }) => {
  if (!bilgi) return <span style={{ fontSize: '13px', color: 'var(--gri-400)' }}>—</span>;
  return <span className={'badge ' + bilgi.renk}>{bilgi.label}</span>;
};

const HRAdaylarPage = () => {
  const [adaylar, setAdaylar] = useState([]);
  const [seciliAdayId, setSeciliAdayId] = useState(null);
  const [filtre, setFiltre] = useState('hepsi');
  const [arama, setArama] = useState('');
  const [pozisyonFiltre, setPozisyonFiltre] = useState('');
  const [firmaFiltre, setFirmaFiltre] = useState('');

  const yukle = () => axios.get('/api/adaylar').then(r => setAdaylar(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, []);

  if (seciliAdayId) {
    return <AdayDetayPage adayId={seciliAdayId} geriDon={() => { setSeciliAdayId(null); yukle(); }} />;
  }

  const pozisyonlar = [...new Set(adaylar.map(a => a.basvuru_pozisyon).filter(Boolean))].sort();
  const firmalar = [...new Set(adaylar.map(a => a.basvuru_musteri).filter(Boolean))].sort();

  const filtrelenmis = adaylar.filter(a => {
    if (filtre === 'yeni' && (a.telefon_durumu || a.teklif_durumu)) return false;
    if (filtre === 'aktif' && (!( a.telefon_durumu || a.teklif_durumu) || elendi(a) || a.teklif_durumu === 'evraklar_yuklendi')) return false;
    if (filtre === 'tamamlandi' && a.teklif_durumu !== 'evraklar_yuklendi') return false;
    if (filtre === 'elendi' && !elendi(a)) return false;
    if (arama && !(a.ad + ' ' + a.soyad + ' ' + a.email + ' ' + (a.telefon||'')).toLowerCase().includes(arama.toLowerCase())) return false;
    if (pozisyonFiltre && (a.basvuru_pozisyon || '').trim() !== pozisyonFiltre.trim()) return false;
    if (firmaFiltre && (a.basvuru_musteri || '').trim() !== firmaFiltre.trim()) return false;
    return true;
  });

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Ise Alim Sureci</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Adaylarin ise alim sureclerini yonetin. Detay icin adaya tiklayin.</p>
      </div>

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart" style={{ cursor: 'pointer' }} onClick={() => setFiltre('hepsi')}>
          <div className="stat-sayi">{adaylar.length}</div><div className="stat-etiket">Toplam</div>
        </div>
        <div className="stat-kart" style={{ cursor: 'pointer' }} onClick={() => setFiltre('yeni')}>
          <div className="stat-sayi" style={{ color: 'var(--sari)' }}>{adaylar.filter(a => !a.telefon_durumu && !a.teklif_durumu).length}</div><div className="stat-etiket">Yeni</div>
        </div>
        <div className="stat-kart" style={{ cursor: 'pointer' }} onClick={() => setFiltre('aktif')}>
          <div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{adaylar.filter(a => (a.telefon_durumu || a.teklif_durumu) && !elendi(a) && a.teklif_durumu !== 'evraklar_yuklendi').length}</div><div className="stat-etiket">Aktif</div>
        </div>
        <div className="stat-kart" style={{ cursor: 'pointer' }} onClick={() => setFiltre('tamamlandi')}>
          <div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{adaylar.filter(a => a.teklif_durumu === 'evraklar_yuklendi').length}</div><div className="stat-etiket">Tamamlandi</div>
        </div>
        <div className="stat-kart" style={{ cursor: 'pointer' }} onClick={() => setFiltre('elendi')}>
          <div className="stat-sayi" style={{ color: 'var(--kirmizi)' }}>{adaylar.filter(elendi).length}</div><div className="stat-etiket">Elendi</div>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {/* Filtre bar */}
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {[
              { key: 'hepsi', label: 'Hepsi' },
              { key: 'yeni', label: 'Yeni' },
              { key: 'aktif', label: 'Aktif' },
              { key: 'tamamlandi', label: 'Tamamlandi' },
              { key: 'elendi', label: 'Elendi' },
            ].map(f => (
              <button key={f.key} className={'btn btn-sm ' + (filtre === f.key ? 'btn-primary' : 'btn-secondary')} onClick={() => setFiltre(f.key)}>
                {f.label}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '8px', flex: 1, flexWrap: 'wrap' }}>
            <input type="text" placeholder="Isim, email, telefon..." value={arama} onChange={e => setArama(e.target.value)} autoComplete="off" style={{ flex: 1, minWidth: '140px', fontSize: '13px' }} />
            <select value={pozisyonFiltre} onChange={e => setPozisyonFiltre(e.target.value)} style={{ fontSize: '13px', minWidth: '140px' }}>
              <option value="">Tum Pozisyonlar</option>
              {pozisyonlar.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
            <select value={firmaFiltre} onChange={e => setFirmaFiltre(e.target.value)} style={{ fontSize: '13px', minWidth: '140px' }}>
              <option value="">Tum Musteriler</option>
              {firmalar.map(f => <option key={f} value={f}>{f}</option>)}
            </select>
            {(arama || pozisyonFiltre || firmaFiltre) && (
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setArama(''); setPozisyonFiltre(''); setFirmaFiltre(''); }}>Temizle</button>
            )}
          </div>
        </div>

        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>👥</div>
            Aday bulunamadi.
          </div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Aday</th>
                  <th>Pozisyon</th>
                  <th>Bas. Musteri</th>
                  <th>Maas Beklenti</th>
                  <th>Sehir</th>
                  <th>Telefon</th>
                  <th>Musteri</th>
                  <th>Teklif</th>
                  <th>Sozlesme</th>
                  <th>Evrak</th>
                  <th>Kayit</th>
                </tr>
              </thead>
              <tbody>
                {filtrelenmis.map(a => {
                  const sozlesmeDurum = ['sozlesme_gonderildi','sozlesme_imzalandi','evraklar_yuklendi'].includes(a.teklif_durumu) ? teklifEtiket[a.teklif_durumu] : null;
                  const evrakDurum = a.teklif_durumu === 'evraklar_yuklendi' ? teklifEtiket['evraklar_yuklendi'] : null;
                  const teklifDurum = ['sozlu_yapildi','resmi_gonderildi','kabul_edildi','reddedildi'].includes(a.teklif_durumu) ? teklifEtiket[a.teklif_durumu] : null;

                  return (
                    <tr key={a.id} onClick={() => setSeciliAdayId(a.id)} style={{ cursor: 'pointer', opacity: elendi(a) ? 0.6 : 1 }}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div className="avatar" style={{ width: '32px', height: '32px', fontSize: '12px', flexShrink: 0 }} data-harf={a.ad[0] || '?'}>{a.ad[0]}{a.soyad[0]}</div>
                          <div>
                            <div style={{ fontWeight: '500', fontSize: '14px' }}>{a.ad} {a.soyad}</div>
                            <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{a.email}</div>
                            {a.telefon && <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{a.telefon}</div>}
                          </div>
                        </div>
                      </td>
                      <td style={{ fontSize: '13px' }}>{a.basvuru_pozisyon || '—'}</td>
                      <td style={{ fontSize: '13px' }}>{a.basvuru_musteri || '—'}</td>
                      <td style={{ fontSize: '13px' }}>{a.maas_beklentisi ? a.maas_beklentisi + ' TL' : '—'}</td>
                      <td style={{ fontSize: '13px' }}>{a.sehir ? a.sehir + (a.ilce ? ' / ' + a.ilce : '') : '—'}</td>
                      <td style={{ borderLeft: '3px solid var(--mavi-acik)' }}><Durum bilgi={telefonEtiket[a.telefon_durumu]} /></td>
                      <td><Durum bilgi={musteriEtiket[a.musteri_durumu]} /></td>
                      <td><Durum bilgi={teklifDurum} /></td>
                      <td><Durum bilgi={sozlesmeDurum} /></td>
                      <td><Durum bilgi={evrakDurum} /></td>
                      <td style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{a.olusturma_tarihi ? new Date(a.olusturma_tarihi).toLocaleDateString('tr-TR') : '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default HRAdaylarPage;
